import { resolveMenuPath } from './menuRouteUtils';

type MenuTreeNode = {
  menuName?: string | null;
  subMenus?: MenuTreeNode[];
};

const MASTER_LIST_PATH = '/sa/MasterList';
const USER_TYPES_PATH = '/sa/business_type';

const isHiddenSuperAdminMenu = (item: MenuTreeNode): boolean => {
  const path = resolveMenuPath(item);
  if (path === MASTER_LIST_PATH || path === USER_TYPES_PATH) {
    return true;
  }
  const name = (item.menuName || '').trim();
  return (
    name === 'Master Catalog' ||
    name === 'MasterList' ||
    name === 'Master List' ||
    name === 'User Types'
  );
};

/** Hides legacy / nested SA items from the sidebar (routes still work). */
export function hideSuperAdminMasterCatalogMenu<T extends MenuTreeNode>(items: T[]): T[] {
  const prune = (nodes: T[]): T[] =>
    nodes
      .filter((node) => !isHiddenSuperAdminMenu(node))
      .map((node) => {
        const subMenus = Array.isArray(node.subMenus) ? prune(node.subMenus as T[]) : [];
        return { ...node, subMenus };
      });

  return prune(items);
}
